import { MEDIA_QUERY } from 'utils/enum/Core';

const drawerWidth = 76;

export default class LayoutStyles {
    static navMenu(theme = {}) {
        return ({
            large: {
                marginLeft: theme.spacing(2),
                marginRight: theme.spacing(2),
                marginBottom: theme.spacing(2),
                width: '38px',
                height: '38px',
                cursor: 'pointer',
            },
            icon: {
                color: '#fff',
                display: 'block',
            },
            list: {
                display: 'flex',
                flexDirection: 'column',
                flexGrow: 1,
                justifyContent: 'space-between',
            },
            listItem: {
                textAlign: 'center',
            },
            activeListItem: {
                backgroundColor: theme.palette.background.white,
                '&:hover': {
                    backgroundColor: theme.palette.background.white,
                },
                '& > div': {
                    color: theme.palette.primary.main,
                    '& > svg > g > g > *': {
                        stroke: theme.palette.primary.main,
                    },
                },
            },
            iconSize: {
                fontSize: '1.8rem',
            },
            navigationTop: {
                flexGrow: 0,
                maxHeight: '70vh',
                overflow: 'auto',
            },
            navigationBottom: {
                flexShrink: 0,
            },
            navHeaderClass: {
                display: 'flex',
                fontSize: '10px',
                marginTop: theme.spacing(2),
                marginBottom: theme.spacing(2),
                maxHeight: '54px',
            },
        });
    }

    static baseLayout(theme = {}) {
        return ({
            root: {
                display: 'flex',
                width: '100%',
                height: '100%',
                overflow: 'hidden',
            },
            rootMobile: {
                overflow: 'hidden',
                [`@media (max-width: ${MEDIA_QUERY.W_992}px)`]: {
                    height: '100%',
                },
            },
            drawer: {
                width: drawerWidth,
                flexShrink: 0,
            },
            drawerPaper: {
                width: drawerWidth,
                backgroundColor: theme.palette.primary.main,
                alignItems: 'center',
                overflow: 'hidden',
            },
            content: {
                display: 'flex',
                flex: 1,
                flexDirection: 'column',
                overflow: 'hidden',
                position: 'relative',
                [`@media (max-width: ${MEDIA_QUERY.W_992}px)`]: {
                    height: '100%',
                },
            },
            menuIcon: {
                color: theme.palette.text.purplelight,
            },
            header: {
                height: '70px',
                display: 'flex',
                alignItems: 'center',
                padding: '0 16px',
                justifyContent: 'end',
                boxShadow: 'rgb(145 158 171 / 20%) 0px 3px 1px -2px, rgb(145 158 171 / 14%) 0px 2px 2px 0px, rgb(145 158 171 / 12%) 0px 1px 5px 0px',
                marginBottom: '12px',
            },
        });
    }
}
